// extracted by mini-css-extract-plugin
export default {"band":"NotFoundPage_band__mDGID","inner":"NotFoundPage_inner__vIzLu","path":"NotFoundPage_path__lS2nV"};